import React from 'react';
import Content from '../../components/Pages/CheckImages';
import { displayName } from '../../../App';
import MainGuidanceLayout from '../../components/Layout/Main';

function CheckImages() {
  document.title = `${displayName}: Check Images`;

  return (
    <MainGuidanceLayout>
      <Content />
    </MainGuidanceLayout>
  );
}

export default CheckImages;
